module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Air Import Details")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "conBooking"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Assignment")]), _vm._v(" "), _c('th', [_vm._v("More Details")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.AirImportData), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewExportAirPage(item1.ffairImportId, item1.statusFinal)
        }
      }
    }, [_c('b', [_vm._v("Assignment No. :")]), _vm._v("\n                  " + _vm._s(item1.airImportSeries) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Importer Client :")]), _vm._v("\n                  " + _vm._s(item1.importerClient) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Exporter Client :")]), _vm._v("\n                  " + _vm._s(item1.exporterClient) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("AirType :")]), _vm._v("\n                  " + _vm._s(item1.containerInfo) + "\n                ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Place of Receipt :")]), _vm._v("\n                  " + _vm._s(item1.placeRecp) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Airport of Departure :")]), _vm._v("\n                  " + _vm._s(item1.placeDis) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Airport of Arrival:")]), _vm._v("\n                  " + _vm._s(item1.LoadPort) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("FPOD :")]), _vm._v("\n                  " + _vm._s(item1.finalPlace) + "\n                  "), _c('br')])])
  }))])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0736404","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientDashboard/clientAirImportDetails.vue
// module id = 2836
// module chunks = 0